import makeStyles from '@material-ui/core/styles/makeStyles';
import { useAppSelector } from 'hooks/redux';
import { isMobile } from 'utils';

const customBottomSpacing = !isMobile.any() ? 60 : 110;
const spacing = 16;

const generics = {
  center: {
    left: '50vw',
    transform: 'translateX(-50%)',
  },
  left: {
    animation: '$toLeftOpen 0.8s linear',
    left: spacing,
  },
  right: {
    animation: '$toRightOpen 0.2s linear',
    right: spacing,
  },
};

const directions = {
  left: {
    top: 110,
    ...generics.left,
  },
  leftEnd: {
    animation: '$toLeftClose 0.2s forwards',
  },
  leftBottom: {
    bottom: 60,
    ...generics.left,
  },
  leftBottomEnd: {
    animation: '$toLeftClose 0.2s forwards',
  },
  right: {
    top: 110,
    ...generics.right,
  },
  rightEnd: {
    animation: '$toRightClose 0.2s forwards',
  },
  rightBottom: {
    bottom: 60,
    ...generics.right,
  },
  rightBottomEnd: {
    animation: '$toRightClose 0.2s forwards',
  },
  topCenter: {
    animation: '$toDownOpen 0.2s linear',
    top: customBottomSpacing,
    ...generics.center,
  },
  topCenterEnd: {
    animation: '$toDownClose 0.2s forwards',
  },
  bottomCenter: {
    animation: '$upwardsOpen 0.2s linear',
    bottom: customBottomSpacing,
    ...generics.center,
  },
  bottomCenterEnd: {
    animation: '$upwardsClose 0.2s forwards',
  },
  teste: () => ({ animation: '$upwardsClose 0.2s forwards' }),
};

const animations = {
  '@keyframes toLeftOpen': {
    from: { left: '-50vw', opacity: 0 },
    to: { left: spacing, opacity: 1 },
  },
  '@keyframes toLeftClose': {
    from: { left: spacing, opacity: 1 },
    to: { left: 0, opacity: 0 },
  },
  '@keyframes toRightOpen': {
    from: { right: '0', opacity: 0 },
    to: { right: spacing, opacity: 1 },
  },
  '@keyframes toRightClose': {
    from: { right: spacing, opacity: 1 },
    to: { right: 0, opacity: 0 },
  },
  '@keyframes upwardsOpen': {
    from: { bottom: '0', opacity: 0 },
    to: { bottom: customBottomSpacing, opacity: 1 },
  },
  '@keyframes upwardsClose': {
    from: { bottom: customBottomSpacing, opacity: 1 },
    to: { bottom: 0, opacity: 0 },
  },
  '@keyframes toDownOpen': {
    from: { top: 0, opacity: 0 },
    to: { top: customBottomSpacing, opacity: 1 },
  },
  '@keyframes toDownClose': {
    from: { top: customBottomSpacing, opacity: 1 },
    to: { top: 0, opacity: 0 },
  },
};

const useStyles = makeStyles((theme) => ({
  customToast: {
    position: 'absolute',
    width: 'fit-content',
    background: '#fff',
    zIndex: 9999,
    padding: '8px 16px',
    borderRadius: '4px',
    boxShadow: '0 1px 10px 0 rgb(0 0 0 / 10%), 0 2px 15px 0 rgb(0 0 0 / 5%)',
  },
  ...directions,
  ...animations,
}));

export const CustomToast = () => {
  const classes = useStyles();
  const { content, isVisible, isClosingTransition, direction } = useAppSelector((state) => state.toast);

  const endAnimation = isClosingTransition ? classes[`${direction}End`] : '';

  return (
    content &&
    isVisible && <div className={`${classes.customToast} ${classes[direction]} ${endAnimation}`}>{content}</div>
  );
};
